module.exports = __webpack_public_path__ + "img/img-16.ae1f9413.webp";